import React from 'react';
import { Typography, Box } from '@mui/material';

const Home = () => {
  return (
    <Box>
      <Typography variant="h3" component="h1" gutterBottom>
        Welcome to CSRP
      </Typography>
      <Typography variant="body1" paragraph>
        Customer Support & Redressal Portal
      </Typography>
    </Box>
  );
};

export default Home;

